import { css } from "styled-components";

export const basicStrokeStyle = css`
  color: var(--text-primary);
  background-color: var(--button-primary-default);
  font-weight: var(--font-weight-regular);
  border: 1px solid var(--button-stroke-border) !important;

  svg:not([data-icon="loading"]) path {
    fill: transparent !important;
    stroke: var(--icon-default) !important;
  }

  &:hover {
    background-color: var(--button-primary-default) !important;
    color: var(--button-primary-hover) !important;
    border: 1px solid var(--button-primary-hover) !important;

    svg:not([data-icon="loading"]) path {
      fill: transparent !important;
      stroke: var(--button-primary-hover) !important;
    }
  }

  &:focus {
    outline: none !important;
    color: var(--text-primary) !important;
    background-color: var(--button-primary-default) !important;
    border: 1px solid var(--button-stroke-border) !important;

    svg:not([data-icon="loading"]) path {
      fill: transparent !important;
      stroke: var(--icon-default) !important;
    }
  }

  &:focus-visible {
    outline: 1px solid var(--button-focused-shadow) !important;
    box-shadow: 0 0 0 2px var(--button-focused-shadow) !important;
  }

  &:active {
    background-color: var(--button-primary-default) !important;
    color: var(--button-primary-clicked) !important;
    border: 1px solid var(--button-primary-clicked) !important;

    svg:not([data-icon="loading"]) path {
      fill: transparent !important;
      stroke: var(--button-primary-clicked) !important;
    }
  }

  &[disabled] {
    color: var(--text-primary);
    background-color: var(--button-primary-default);
    border: 1px solid var(--button-stroke-border) !important;
    opacity: 0.5;

    &:hover {
      color: var(--text-primary);
      background-color: var(--button-primary-default);
      border: 1px solid var(--button-stroke-border) !important;
      opacity: 0.5;
    }
  }
`;
